import { useCallback } from 'react';

export const useOpenInbox = () => useCallback((event) => {
    event.preventDefault();

    if (!window.Communication) {
        return;
    }

    const api = window.Communication.API;
    const windowStatus = api?.inbox.getWindowStatus();

    if (windowStatus?.close) {
        return api.inbox.showInboxTab();
    }

    if (windowStatus?.hide) {
        api?.chat.minimize();

        return api.inbox.maximize();
    }
}, []);
